import { TableCell, TableRow, Typography, useTheme } from "@mui/material";
import { RmWiseFreezeDistributionObj } from "../../../redux-store/types/onBoarding";
import CustomTable from "../../investorOverview/common/customTable";
import { PaginationObj, TableHeaderData } from "../../investorOverview/types";
import { useMemo, useState } from "react";

const headerData: TableHeaderData[] = [
    {
        id: 'rmName',
        label: 'RM Name',
        align: 'left',
        isSortable: false,
    },
    {
        id: 'totalEntities',
        label: 'Total Entities',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'freezed',
        label: 'Freezed',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'unfreezed',
        label: 'Unfreezed',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'freezedPerc',
        label: 'Freezed %',
        align: 'center',
        isSortable: false,
    },
]

function DataTable({ tableBodyData }: { tableBodyData: Array<RmWiseFreezeDistributionObj>; }): JSX.Element {
    const theme = useTheme()

    return (
        <>
            {
                tableBodyData.map((obj: RmWiseFreezeDistributionObj, index: number) => {
                    return (
                        <TableRow
                            key={`${obj.rmName}-${index}`}
                            sx={{
                                height: "4.5em",
                                '& td': {
                                    padding: "5px",
                                    height: "4.5em",
                                    borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                },
                                '& td:first-of-type': {
                                    paddingLeft: "15px"
                                },
                            }}
                        >
                            <TableCell align="left">
                                <Typography
                                    variant="body_500"
                                    sx={{
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                    }}
                                >
                                    {obj?.rmName || "-"}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={{
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                    }}
                                >
                                    {obj?.totalEntities ?? "-"}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={{
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                    }}
                                >
                                    {obj?.count ?? "-"}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={{
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                        textTransform: "uppercase"
                                    }}
                                >
                                    {!(
                                        (Number.isNaN(Number(obj?.totalEntities))) ||
                                        (Number.isNaN(Number(obj?.count)))
                                    ) ? (Number(obj?.totalEntities) - Number(obj?.count)) : "-"}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={{
                                        lineHeight: "20px",
                                        letterSpacing: "0.02px",
                                        color: theme.palette.text.primary,
                                    }}
                                >
                                    {!(Number.isNaN(Number(obj?.percentage))) ? (Math.round(Number(obj.percentage) * 100) / 100) : "-"}
                                </Typography>
                            </TableCell>
                        </TableRow >
                    )
                })
            }
        </>
    )
}

export default function FreezePercTable({
    tableData,
}: {
    tableData: Array<RmWiseFreezeDistributionObj>
}): JSX.Element {
    const [paginationObj, setPaginationObj] = useState<PaginationObj>({
        currentPage: 0,
        rowsPerPage: 5,
        totalRows: (tableData ?? []).length
    })

    const handleTableRowsPerPageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);

        setPaginationObj(prev => ({
            ...prev,
            currentPage: 0,
            rowsPerPage: newRowsPerPage
        }));
    }

    const handleTablePageChange = async (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        setPaginationObj(prev => ({
            ...prev,
            currentPage: page
        }));
    }

    const currentTableData = useMemo(() => {
        const { currentPage, rowsPerPage } = paginationObj;

        const startIndex = currentPage * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;

        return tableData.slice(startIndex, endIndex);
    }, [
        tableData,
        paginationObj.currentPage,
        paginationObj.rowsPerPage
    ]);

    return (
        <CustomTable
            isLoading={false}
            tableBody={
                <DataTable tableBodyData={currentTableData} />
            }
            tableData={currentTableData}
            tableHeaderData={headerData}
            tableHeadRowCustomStyles={{
                '& th:first-of-type': {
                    paddingLeft: "15px"
                }
            }}
            tableBodyCustomStyles={{
                '& tr:last-child td': {
                    border: 0
                }
            }}
            loadingRowsNum={7}
            tableDataCount={paginationObj.totalRows}
            rowsPerPage={paginationObj.rowsPerPage}
            rowsPerPageOptions={[5, 10, 15, 20]}
            handleRowsPerPageChange={handleTableRowsPerPageChange}
            handlePageChange={handleTablePageChange}
            currentPage={paginationObj.currentPage}
        />
    )
}